import { Theme, Radio } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React, { useMemo } from 'react';
import { getStateDesc } from '../LandsFormHelper';
import { selectMiscellaneousPlacementData } from 'store/redux-store/placement-details/selectors';
import { useSelector } from 'react-redux';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme: Theme) => ({
  listItems: {
    padding: '18px 18px !important',
  },
}));
export const LicenseSelection = props => {
  const { t } = useTranslation();
  const { handleLicenseSel, currentRadio, isLicenseNumStateMissing, setIsLicenseNumStateMissing } = props;
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const { classes } = useStyles();

  const handleClickOnLicense = license => {
    license?.stateID === null ||
    license?.licenseStateProvince === null ||
    (license?.lookups?.find(item => item.lookUpField === 'LicenseNumber') && license?.licenseNumber === null)
      ? setIsLicenseNumStateMissing(true)
      : setIsLicenseNumStateMissing(false);
  };
  const SelectionList = useMemo(() => {
    return (
      <>
        {licensesList?.map((item, idx) => {
          return (
            <>
              <LayoutGridItem item>
                <LayoutGrid container direction="row" spacing={1}>
                  <LayoutGridItem
                    item
                    xs={1}
                    onClick={() => {
                      handleClickOnLicense(item);
                    }}
                  >
                    <Radio
                      name={`License_${item?.requirementID}`}
                      checked={
                        currentRadio === `License_${item?.requirementID}` &&
                        !(item?.stateID === null) &&
                        !isLicenseNumStateMissing
                      }
                      onChange={e => {
                        //setSelectedRadio(`License_${item?.requirementID}`);
                        handleLicenseSel(item?.requirementID);
                      }}
                      disabled={
                        !props.hasEditAccess ||
                        item?.stateID === null ||
                        item?.licenseStateProvince === null ||
                        (item?.lookups?.find(license => license.lookUpField === 'LicenseNumber') &&
                          item?.licenseNumber === null)
                      }
                    />
                  </LayoutGridItem>
                  <LayoutGridItem item className={classes.listItems} xs={3}>
                    {`${
                      item?.stateID
                        ? getStateDesc(item?.stateID)
                        : item?.licenseStateProvince
                        ? item?.licenseStateProvince
                        : '--'
                    }`}
                  </LayoutGridItem>
                  <LayoutGridItem item className={classes.listItems} xs={2}>
                    {`${
                      item?.licenseNumber
                        ? item?.licenseNumber
                        : !item?.lookups?.find(item => item.lookUpField === 'LicenseNumber')
                        ? 'N/A'
                        : '--'
                    }`}
                  </LayoutGridItem>
                  <LayoutGridItem item className={classes.listItems} xs={6}>
                    {item?.credentialName ? (
                      item?.credentialName
                    ) : (
                      <LayoutGrid>
                        <LayoutGridItem>{'--'}</LayoutGridItem>
                        <LayoutGridItem>
                          <CustomTooltip
                            tooltipContent={t(
                              'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseSelection.licenseNameMissing',
                            )}
                          >
                            <InfoOutlinedIcon style={{ color: '#3CA0F5' }} />
                          </CustomTooltip>
                        </LayoutGridItem>
                      </LayoutGrid>
                    )}
                  </LayoutGridItem>
                </LayoutGrid>
              </LayoutGridItem>
            </>
          );
        })}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRadio, handleLicenseSel, licensesList]);

  return <>{SelectionList}</>;
};
